import React from 'react'
import BreadcrumbSecondaryItem, {
  IBreadcrumbSecondaryItem,
} from './BreadcrumbSecondaryItem'

export interface IBreadcrumSecondaryProps {
  items: IBreadcrumbSecondaryItem[]
}

const BreadcrumbsSecondary = (props: IBreadcrumSecondaryProps) => {
  return (
    <nav className="breadcrumbs dnd-s-mob">
      <ol>
        {props?.items.map((item, key) => {
          return <BreadcrumbSecondaryItem key={key} item={item} />
        })}
      </ol>
    </nav>
  )
}

export default BreadcrumbsSecondary
